module.exports = __webpack_public_path__ + "static/img/2.61159f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/eng/2.png
// module id = TUv+
// module chunks = 0